<template>
  <v-btn
    data-test-id="back-to-deepbox"
    prepend-icon="fas fa-chevron-left"
    variant="plain"
    @click="goBack"
  >
    <span class="d-none d-sm-flex align-md-center font-weight-light">
      {{ originApp }}
    </span>
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const router = useRouter();
const i18n = useI18n();

const backUrl = computed(() => route.query?.backUrl);

const urlType = computed(() => {
  if (!backUrl.value) return undefined;

  try {
    // Check for portal url, return 'portal'
    const regexPortal = /^portal\.((dev(\d+)?|int|demo)\.|)deepbox\.swiss$/;
    const url = new URL(decodeURIComponent(String(backUrl.value)));
    // Check for deepbox url, return 'deepbox'
    const regexDeepBox = /^((dev(\d+)?|app|int|demo)\.|)deepbox\.swiss$/;
    if (regexPortal.test(String(url.hostname))) return 'portal';
    if (regexDeepBox.test(String(url.hostname))) return 'deepbox';
    if (String(url.hostname).startsWith('localhost')) return 'localhost';
  } catch (e) {
    console.error('Invalid URL:', backUrl.value, e);
  }
  return undefined;
});

const originApp = computed(() => {
  switch (urlType.value) {
    case 'portal':
      return i18n.t('buttons.back_to_deepportal');
    case 'deepbox':
      return i18n.t('buttons.back_to_deepbox');
    case 'localhost':
      return i18n.t('buttons.back');
    default:
      return i18n.t('buttons.overview');
  }
});

function goBack() {
  if (backUrl.value && urlType.value) {
    console.log('backUrl', backUrl.value);
    console.log('urlType', urlType.value);
    window.open(String(backUrl.value), '_self');
  } else {
    const filterSignStatus = sessionStorage.getItem('filterSignStatusSession');
    const filterDocumentStatus = sessionStorage.getItem(
      'documentSignStatusSession'
    );

    router.push({
      name: 'dashboard',
      query: {
        ...route.query,
        ...(filterDocumentStatus
          ? filterDocumentStatus.split(',').reduce(
              (acc, status) => {
                acc.filterDocumentStatus = acc.filterDocumentStatus
                  ? [...acc.filterDocumentStatus, status]
                  : [status];
                return acc;
              },
              {} as { filterDocumentStatus?: string[] }
            )
          : {}),
        ...(filterSignStatus
          ? filterSignStatus.split(',').reduce(
              (acc, status) => {
                acc.filterSignStatus = acc.filterSignStatus
                  ? [...acc.filterSignStatus, status]
                  : [status];
                return acc;
              },
              {} as { filterSignStatus?: string[] }
            )
          : {})
      }
    });
  }
}
</script>
